import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handleGetRequest } from "../../../services/GetTemplate";
import { useHistory } from "react-router-dom";
import { handlePostRequest } from "../../../services/PostTemplate";

function CreateSingleTransaction() {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [productOptions, setproductOptions] = useState([]);
    const [transactionStatus, setTransactionStatus] = useState("");
    const [disableFields, setDisableFields] = useState("");
    const [paymentMode, setPaymentMode] = useState([]);
    const [productName, setProductName] = useState("");
    const [beneAccNo, setBeneAccNo] = useState("");
    const [productId, setProductId] = useState("");

    useEffect(() => {
        handleGetRequest("/zbizgateway/lov/lovAuthCompanyProducts/").then((res) => {
            setproductOptions(res?.data);
        });
    }, []); // eslint-disable-line

    const handleProduct = (companydata) => {
        setProductId(companydata?.productId);
        setTransactionStatus(companydata);
        setProductName(companydata?.masterProductName);
        if (companydata?.productId !== undefined) {
            formik.setFieldValue("debitAcctNoId", companydata?.custAccDr);
        }
    };

    const handleSecurity = (value) => {
        if (value.length === 7) {
            handlePostRequest({ securityPin: value }, "/zbizgateway/nonFin/verifySecurityDeviceCode").then((res) => {
                setDisableFields(res?.data);
            });
        }
    };
    useEffect(() => {
        handleGetRequest("/zbizgateway/lov/lovPaymentMode").then((res) => {
            setPaymentMode(res?.data);
        });
    }, []); // eslint-disable-line

    const documentOptions = [
        { label: "Driving License", value: "D" },
        { label: "Cnic", value: "C" },
        { label: "Passport", value: "P" },
    ];

    const cancelHandler = (e) => {
        e.preventDefault();
    };

    const handleBeneAccountNo = (e) => {
        setBeneAccNo(e);
    };

    const handleBenAccountNo = async (e) => {
        e.preventDefault();
        const res = await handlePostRequest({ accNo: beneAccNo }, "zbizgateway/nonFin/initiateSingleTransactionTitleFetch");
        formik.setFieldValue("accountTitle", res?.data?.accountTitle);
    };

    const formik = useFormik({
        initialValues: {
            securityDeviceCode: null,
            productId: null,
            debitAcctNoId: null,
            benBank: null,
            benActNo: null,
            benBankId: null,
            accountTitle: null,
            custRef: null,
            benEmail: null,
            docType: null,
            payModeId: null,
            mobileNo: null,
            transferAmnt: null,
            docNo: null,
            beneficiaryAddress: null,
            beneficiaryName: null,
            benName: null,
            benAccTitle: null,
        },
        validate: (data) => {
            let errors = {};
            if (!data.securityDeviceCode) {
                errors.securityDeviceCode = "This field is required.";
            }

            if (!data.productId) {
                errors.productId = "This field is required.";
            }
            if (transactionStatus?.benBank === "Y") {
                if (!data.benBank) {
                    errors.benBank = "This field is required.";
                }
            }

            if (transactionStatus?.benAccNO === "Y") {
                if (!data.benActNo) {
                    errors.benActNo = "This field is required.";
                }
            }
            if (transactionStatus?.benAccTitle === "Y") {
                if (!data.accountTitle) {
                    errors.accountTitle = "This field is required.";
                }
            }

            if (!data.custRef) {
                errors.custRef = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            data["productId"] = data?.productId?.productId?.toString();
            data["payModeId"] = data?.payModeId?.id;
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            await handlePostRequest(data, "zbizgateway/nonFin/initiateSingleTransaction");
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Single Transaction</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="secuirtyDeviceCode" className={classNames({ "p-error": isFormFieldValid("secuirtyDeviceCode") }, "Label__Text")}>
                                Secuirty Device Code <span className="Label__Required">*</span>
                            </label>
                            <InputText
                                id="securityDeviceCode"
                                placeholder=""
                                name="securityDeviceCode"
                                value={formik.values.securityDeviceCode}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    handleSecurity(e.target.value);
                                }}
                                maxLength="7"
                                className={classNames({ "p-invalid": isFormFieldValid("securityDeviceCode") }, "Input__Round")}
                            />

                            {getFormErrorMessage("securityDeviceCode")}
                        </div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="productId" className={classNames({ "p-error": isFormFieldValid("productId") }, "Label__Text")}>
                                Product Name<span className="Label__Required">*</span>
                            </label>
                            <Dropdown
                                id="productId"
                                placeholder="Enter Product"
                                disabled={disableFields === "Y" ? false : true}
                                options={productOptions}
                                optionLabel="masterProductName"
                                name="productId"
                                value={formik.values.productId}
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    handleProduct(e.target.value);
                                }}
                                className={classNames({ "p-invalid": isFormFieldValid("productId") }, "Dropdown__Round")}
                            />
                            {getFormErrorMessage("productId")}
                        </div>
                    </div>

                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="debitAcctNoId" className={classNames({ "p-error": isFormFieldValid("debitAcctNoId") }, "Label__Text")}>
                                Debit Account Number <span className="Label__Required">*</span>
                            </label>
                            <InputText id="debitAcctNoId" disabled placeholder="" name="debitAcctNoId" value={formik.values.debitAcctNoId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("debitAcctNoId") }, "Input__Round")} />

                            {getFormErrorMessage("debitAcctNoId")}
                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-d-flex p-jc-end">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="custRef" className={classNames({ "p-error": isFormFieldValid("custRef") }, "Label__Text")}>
                                    Customer Reference <span className="Label__Required">*</span>
                                </label>
                                <InputText id="custRef" placeholder="" name="custRef" disabled={disableFields === "Y" ? false : true} value={formik.values.custRef} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("custRef") }, "Input__Round")} />

                                {getFormErrorMessage("custRef")}
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-6 p-d-flex">
                        <div className="p-field p-col-12 p-md-6">
                            <div className="p-field">
                                <label htmlFor="transferAmnt" className={classNames({ "p-error": isFormFieldValid("transferAmnt") }, "Label__Text")}>
                                    Transfer Amount <span className="Label__Required">*</span>
                                </label>
                                <InputText
                                    id="transferAmnt"
                                    placeholder=""
                                    name="transferAmnt"
                                    disabled={disableFields === "Y" ? false : true}
                                    value={formik.values.transferAmnt}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("transferAmnt") }, "Input__Round")}
                                />

                                {getFormErrorMessage("transferAmnt")}
                            </div>
                        </div>
                    </div>
                    {transactionStatus?.benBank === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="benBank" className={classNames({ "p-error": isFormFieldValid("benBank") }, "Label__Text")}>
                                    Beneficiary Bank Name<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="benBank"
                                    placeholder="Enter Product"
                                    options={debitAccountOptions}
                                    optionLabel="Beneficiary Bank Name"
                                    name="benBank"
                                    value={formik.values.benBank}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("benBank") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("benBank")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.benAccNO === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="benActNo" className={classNames({ "p-error": isFormFieldValid("benActNo") }, "Label__Text")}>
                                    Beneficiary Account Number <span className="Label__Required">*</span>
                                </label>
                                <div className="p-d-flex Search__Round">
                                    <InputText
                                        id="benActNo"
                                        placeholder=""
                                        name="benActNo"
                                        value={formik.values.benActNo}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            handleBeneAccountNo(e.target.value);
                                        }}
                                        className={classNames({ "p-invalid": isFormFieldValid("benActNo") }, "Input__Round")}
                                    />
                                    <Button icon="pi pi-search" onClick={(e) => handleBenAccountNo(e)} className="p-button-rounded p-button-success p-button-text" />
                                </div>
                                {getFormErrorMessage("benActNo")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    {transactionStatus?.benAccTitle === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="accountTitle" className={classNames({ "p-error": isFormFieldValid("accountTitle") }, "Label__Text")}>
                                    Beneficiary Account Title <span className="Label__Required">*</span>
                                </label>
                                <InputText id="accountTitle" placeholder="" disabled name="accountTitle" value={formik.values.accountTitle} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("accountTitle") }, "Input__Round")} />

                                {getFormErrorMessage("accountTitle")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.benEmail === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="benEmail" className={classNames({ "p-error": isFormFieldValid("benEmail") }, "Label__Text")}>
                                    Beneficiary Email
                                </label>

                                <InputText id="benEmail" placeholder=" " name="benEmail" value={formik.values.benEmail} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("benEmail") }, "Input__Round")} />
                                {getFormErrorMessage("benEmail")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.paymentMode === "Y" ? (
                        <div className="p-field p-col-12 p-md-3">
                            <div className="p-field">
                                <label htmlFor="payModeId" className={classNames({ "p-error": isFormFieldValid("payModeId") }, "Label__Text")}>
                                    Payment Mode<span className="Label__Required">*</span>
                                </label>
                                <Dropdown
                                    id="payModeId"
                                    placeholder="Enter Product"
                                    options={paymentMode}
                                    optionLabel="description"
                                    name="payModeId"
                                    value={formik.values.payModeId}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("payModeId") }, "Dropdown__Round")}
                                />
                                {getFormErrorMessage("payModeId")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}

                    {transactionStatus?.mobileNo === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="mobileNo" className={classNames({ "p-error": isFormFieldValid("mobileNo") }, "Label__Text")}>
                                    Mobile Number
                                </label>
                                <InputText id="mobileNo" placeholder=" " name="mobileNo" value={formik.values.mobileNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("mobileNo") }, "Input__Round")} type="number" />

                                {getFormErrorMessage("mobileNo")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.documentType === "Y" ? (
                        <div className="p-field p-col-12 p-md-3">
                            <div className="p-field">
                                <label htmlFor="docType" className={classNames({ "p-error": isFormFieldValid("docType") }, "Label__Text")}>
                                    Document Type<span className="Label__Required">*</span>
                                </label>
                                <Dropdown id="docType" placeholder="Enter Product" options={documentOptions} optionLabel="label" name="docType" value={formik.values.docType} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("docType") }, "Dropdown__Round")} />
                                {getFormErrorMessage("docType")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.documentNo === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="docNo" className={classNames({ "p-error": isFormFieldValid("docNo") }, "Label__Text")}>
                                    Document Number <span className="Label__Required">*</span>
                                </label>
                                <InputText id="docNo" placeholder="" name="docNo" value={formik.values.docNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("docNo") }, "Input__Round")} />

                                {getFormErrorMessage("docNo")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.benName === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="beneficiaryName" className={classNames({ "p-error": isFormFieldValid("beneficiaryName") }, "Label__Text")}>
                                    Benefical Name <span className="Label__Required">*</span>
                                </label>
                                <InputText id="beneficiaryName" placeholder="" name="beneficiaryName" value={formik.values.beneficiaryName} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("beneficiaryName") }, "Input__Round")} />

                                {getFormErrorMessage("beneficiaryName")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {transactionStatus?.benAddress === "Y" ? (
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="beneficiaryAddress" className={classNames({ "p-error": isFormFieldValid("beneficiaryAddress") }, "Label__Text")}>
                                    Benefical Address <span className="Label__Required">*</span>
                                </label>
                                <InputText id="beneficiaryAddress" placeholder="" name="beneficiaryAddress" value={formik.values.beneficiaryAddress} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("beneficiaryAddress") }, "Input__Round")} />

                                {getFormErrorMessage("beneficiaryAddress")}
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <div className="Down__Btn">
                    <Button label="Cancel" className="Btn__Transaction__Transparent" onClick={(e) => cancelHandler(e)} />
                    <Button label="Submit" type="submit" className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
}

export default CreateSingleTransaction;
